import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Flex, Header, Image, Text } from '@fluentui/react-northstar';
import LoginImage from 'images/login/users.png';
import { useAppContext } from 'contexts/AppContext';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const Maintenance = (): React.ReactElement => {
  const history = useHistory();
  const { token, tenant } = useSelector((state: RootState) => state.auth);
  const { tenantTheme } = useAppContext();

  useEffect(() => {
    if (!token) return;
    history.push(!tenant ? '/partner' : '/');
  }, [history, token, tenant]);

  const APP_NAME = process.env.REACT_APP_INSTANCE_NAME ?? 'Symbio';

  return (
    <Flex
      hAlign="center"
      vAlign="center"
      style={{ height: '100vh', backgroundColor: '#f6f6f6', margin: '-0.5rem -1.5rem' }}
    >
      <Flex key="center" hAlign="center" vAlign="center" style={{ width: 350, padding: 20, textAlign: 'center' }}>
        <Box>
          <Header color="brand" as="h1" content={`Welcome to ${tenantTheme?.appName || APP_NAME}`} />
          <Text size="large" content="Symbio Calling is currently down for planned maintenance until 7th April." />
          <Box style={{ maxWidth: 600 }}>
            <Image src={tenantTheme?.loginImageUrl || LoginImage} style={{ margin: '30px 0', width: '100%' }} />
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Maintenance;
